import { useMemo, useState } from "react";
import { movies, movieGenres } from "@/mocks/homeData";

export default function MovieSection() {
  const [genre, setGenre] = useState("全部");

  const list = useMemo(
    () => (genre === "全部" ? movies : movies.filter((m) => m.genre === genre)),
    [genre]
  );

  return (
    <section id="movies" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
              HD Movies
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              中文在线高清影视资源精选
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              中文字幕同步更新，题材覆盖剧情、悬疑、科幻、古装与国风动画。
              点击下方标签可切换分类，只看你感兴趣的题材。
            </p>
          </div>
          <div className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
            当前分类共 <span className="font-bold text-primary-700">{list.length}</span> 部
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2" role="tablist" aria-label="影视题材筛选">
          {movieGenres.map((g) => (
            <button
              key={g}
              type="button"
              role="tab"
              aria-selected={genre === g}
              onClick={() => setGenre(g)}
              className={`px-4 py-2 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                genre === g
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {g}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {list.map((movie) => (
            <article
              key={movie.id}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-colors hover:border-primary-300"
            >
              <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 影视封面`}
                  title={`${movie.title} 中文在线高清影视`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-[11px] whitespace-nowrap">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  {movie.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-foreground-950/75 text-background-50 text-[11px] font-medium">
                  {movie.rating} 分
                </span>
              </div>

              <div className="p-4">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">{movie.genre}</span>
                  <span>{movie.year}</span>
                </div>
                <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950">
                  {movie.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{movie.episode}</p>
                <p className="mt-2.5 text-xs text-foreground-600 leading-relaxed line-clamp-3">
                  {movie.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}